import React, { useState } from 'react';
import { Modal } from '@arco-design/web-react';
import { formatNumber, formatPercent } from '../../service/workbench';

interface MetricCardProps {
  title: string;
  value?: number | null;
  unit?: string;
  hint?: React.ReactNode;
  percent?: boolean;
  emphasis?: boolean;
  /** 数值颜色：up 红、down 绿 */
  tone?: 'up' | 'down';
  change?: number | null;
  changeLabel?: string;
  /** 右上角「?」的帮助内容，传入后显示圆形按钮和口径弹窗 */
  help?: React.ReactNode;
}

export default function MetricCard({
  title,
  value,
  unit,
  hint,
  percent,
  emphasis,
  tone,
  change,
  changeLabel = '较上一周期',
  help
}: MetricCardProps) {
  const [helpVisible, setHelpVisible] = useState(false);

  return (
    <section className="metric-card">
      <div className="metric-card__title">
        <span>{title}</span>
        {help && (
          <button
            type="button"
            className="metric-card__help"
            aria-label={`${title} 数据口径`}
            onClick={() => setHelpVisible(true)}
          >
            ?
          </button>
        )}
      </div>
      <div className={`metric-card__value ${emphasis ? 'is-emphasis' : ''} ${tone ? `is-${tone}` : ''}`}>
        {percent ? formatPercent(value) : formatNumber(value)}
        {unit && <span>{unit}</span>}
      </div>
      <div className="metric-card__hint">
        {change !== undefined && change !== null && (
          <span className={change >= 0 ? 'trend-up' : 'trend-down'}>
            {change >= 0 ? '↑' : '↓'} {Math.abs(change).toFixed(1)}% {changeLabel}
          </span>
        )}
        {hint}
      </div>
      {help && (
        <Modal
          title={`${title} 数据口径`}
          visible={helpVisible}
          footer={null}
          onCancel={() => setHelpVisible(false)}
          style={{ width: 520 }}
        >
          <div className="metric-help">{help}</div>
        </Modal>
      )}
    </section>
  );
}
